<template>
  <div class="audit-label">
    <div class="audit-label-info">
      <span class="audit-label-info-key"></span>
      <span class="audit-label-info-value">暂未认证身份信息</span>
    </div>
    <div class="audit-label-info">
      <span class="audit-label-info-key"></span>
      <span class="audit-label-info-value">
        <span style="color: #999999;">请完成身份认证信息填写，审核通过后可进行创建应用，获取稿件分发等开发者能力</span>
        <span style="color: #999999;"> | </span>
        <span class="link"><router-link :to="{name: 'companyAdd'}">去填写</router-link></span>
      </span>
    </div>
    <div class="audit-label-info">
      <span class="audit-label-info-key"></span>
      <span class="audit-label-info-value">
        <span style="color: #999999;">如果您是被授权用户，请前往【管理中心 - 授权管理】接受授权邀请 </span>
        <span style="color: #999999;"> | </span>
        <span class="link"><router-link :to="{name: 'auth'}">去接受邀请</router-link></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "unsubmit"
}
</script>

<style scoped lang="scss">
.audit-label {
  .audit-label-info {
    padding: 16px 34px 0;
    .audit-label-info-key {
      font-size: 14px;
      color: #505050;
      display: inline-block;
      width: 180px;
    }

    .audit-label-info-value {
      font-size: 14px;
      color: #505050;

      .link {
        background: #F7FBFF;
        border-radius: 4px;
        font-size: 12px;
        color: #00A1D6;
        padding: 6px 9px;
      }
    }
  }
}
</style>
